import { render, staticRenderFns } from "./navUser.vue?vue&type=template&id=4abe4ec6&scoped=true&"
import script from "./navUser.vue?vue&type=script&lang=js&"
export * from "./navUser.vue?vue&type=script&lang=js&"
import style0 from "./navUser.vue?vue&type=style&index=0&id=4abe4ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abe4ec6",
  null
  
)

export default component.exports